import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import * as ngswal from "sweetalert";
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FreelancerlistAPIModel } from '../freelancerlist/freelancerlistmodel';
import { connect } from 'tls';
import { Observable } from 'rxjs';
declare var $;
@Component({
  selector: 'app-freelancer-dashboard',
  templateUrl: './freelancer-dashboard.component.html',
  styleUrls: ['./freelancer-dashboard.component.css']
})
/** FreelancerDashboard component*/
export class FreelancerDashboardComponent implements OnInit {

  months = [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 }
  ];
  selectedYear!: number;
  selectedMonth!: number;
  weeks: any[][] = [];
  today: Date = new Date();
  currentDay!: number;
  dataSet: string;
  dataTable: any;
  modelItem: FreelancerlistAPIModel;
  Freelancerid: any;

  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  VendorName: any;
  EmailID: any;
  MicrosoftTeamId: any;
  Interest: any;
  Restriction: any;
  Country: any;
  StateProvince: any;
  City: any;
  AlternateEmailID: any;
  ContactNo: any;
  DOB: any;
  Gender: any;
  Address: any;
  ZIPPostCode: any;
  Category: any;
  Notes: any;
  Response: string;
  Source: any;
  Languages: any;
  file: any;
  fileBase64: any;
  Data: string;
  startDate: string;
  endDate: string;
  validateDateRange: any;
  minDate: string;
  maxDate: string;
  Description: any;
  appendElement: any;
  currentView: string;

  /** FreelancerDashboard ctor */
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <FreelancerlistAPIModel>data["FreelancerlistPage"];
        this.GetFreelancerData();
        this.ShowAvailability();
        $('.container-fluid').css('height', GlobalConstants.size.height - 140);
        $('#TXT_Remarks').css('height', GlobalConstants.size.height - 660);


      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  /** register ctor */
  ngOnInit() {
    ApiMethod.getBaseUrl();
    this.selectedYear = this.today.getFullYear();
    this.selectedMonth = this.today.getMonth() + 1; // JavaScript months are 0-indexed
    this.currentDay = this.today.getDate();
    this.generateCalendar();
    this.GetDueDateValidation();

    /*  this.GetDueDateValidationOnDate();*/

    /* $('#popupData').css('height', (GlobalConstants.size.height - 650));*/
    this.route.queryParamMap.subscribe(params => {
      if (params.get("Flid") != null) {
       
        localStorage.aEID = params.get("Flid");
        localStorage.aLoginID = params.get("Flid");
        $("#LoadingImage").show();
        var userItem = {
          RoleId: 24
        };
        ApiMethod.postMethod("api/menuaccessList", userItem).subscribe(
          resonse => {
            let aMenuList = resonse.aMenuAccessList;
            localStorage.aMenuList = JSON.stringify(aMenuList);
            
            $("#LoadingImage").hide();
          },
          error => {
            console.error(error)
            $("#LoadingImage").hide();
          }
        );
        
      }
      else {
        localStorage.aEID = localStorage.aLoginID;
        // ngswal("Warning !", 'Invalid URL !', "warning");
      }
    });
  }

  generateCalendar() {

    this.weeks = [];
    let firstDayOfMonth = new Date(this.selectedYear, this.selectedMonth - 1, 1).getDay();
    let numberOfDays = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
    let dayCounter = 1;

    // Calculate total cells needed for the month including padding
    let totalCells = firstDayOfMonth + numberOfDays;
    let totalWeeks = Math.ceil(totalCells / 7);

    for (let week = 0; week < totalWeeks; week++) {
      const weekDays = [];

      for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
        if (week === 0 && dayOfWeek < firstDayOfMonth || dayCounter > numberOfDays) {
          // Add padding for days before the first of the month or after the last day
          weekDays.push(null);
        } else {
          weekDays.push(dayCounter++);
        }
      }
      this.weeks.push(weekDays);
    }
  }




  get currentMonthName(): string {
    return this.months.find(month => month.value === this.selectedMonth)?.name || '';
  }

  incrementMonth() {
    if (this.selectedMonth === 12) {
      this.selectedYear++;
      this.selectedMonth = 1;
    } else {
      this.selectedMonth++;
    }
    this.generateCalendar();
  }

  decrementMonth() {
    if (this.selectedMonth === 1) {
      this.selectedYear--;
      this.selectedMonth = 12;
    } else {
      this.selectedMonth--;
    }
    this.generateCalendar();

  }

  GetDueDateValidation() {

    var today = new Date();
    var tenDaysFromNow = new Date(today.getTime() + 10 * 24 * 60 * 60 * 1000);
    this.minDate = today.toISOString().slice(0, 10);
    this.maxDate = tenDaysFromNow.toISOString().slice(0, 365);
    var dueDate = new Date('dd-mm-yyyy');
    if (dueDate > today) {
      ngswal("Warning !", "Due date must be today or in the past", "warning");
    } else if (dueDate > tenDaysFromNow) {
      ngswal("Warning !", "Due date must be within 10 days from today", "warning");
    }
  }


  GetFreelancerData() {

    $("LoadingImage").show();

    var FreelancerDetails = {
      LoginID: localStorage.aLoginID,
      //PublisherId: localStorage.aPubID,
      ID: localStorage.aLoginID
    };
    console.log(FreelancerDetails);

    ApiMethod.postMethod("api/GetFreelancerDetailsID", FreelancerDetails).subscribe(
      Response => {
        console.log(Response.aFreelancerDetails);
        console.log(Response.GridColumnListData);

        this.dataSet = JSON.stringify(Response.aFreelancerDetails); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        var hegiht = (GlobalConstants.size.height * 0.80);
        //Dynamic datable
        let aColList = Response.GridColumnListData; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList; 
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - hegiht);
        dataItem.modulename = 'FreelancerRegisterModule';
        //dataItem.aNewButtonName = '';
        dataItem.infoPopupID = 'ID';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  getpopupFreelancerdate() {
    $("LoadingImage").show();
    $('#divInfoData').show();
    if (localStorage.aEID != 0) {

      ApiMethod.getMethod("api/FreelancerDataByID/" + localStorage.aEID).subscribe(
        Response => {
          var _data = Response.aList;
          console.log(_data);
          this.VendorName = _data[0].VendorName;
          this.EmailID = _data[0].EmailID;
          this.MicrosoftTeamId = _data[0].MicrosoftTeamId;
          this.AlternateEmailID = _data[0].AlternateEmailID;
          this.ContactNo = _data[0].ContactNo;
          this.DOB = _data[0].DOB;
          this.Gender = _data[0].Gender;
          this.Address = _data[0].Address;
          this.ZIPPostCode = _data[0].ZIPPostCode;
          this.Country = _data[0].CountryName;
          this.StateProvince = _data[0].StateName;
          this.City = _data[0].CityName;
          this.Source = _data[0].SourceName;
          this.Languages = _data[0].Language;
          this.Restriction = _data[0].Restriction;
          this.Interest = _data[0].Interest;
          this.Category = _data[0].Category;
          this.Notes = _data[0].Notes;
          this.Description = _data[0].Description;
          this.Response = "Info";

        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }
  isSelectedDate(day: number): boolean {
    const selectedFromDate = new Date($('#Txt_From').val());
    const selectedToDate = new Date($('#Txt_To').val());
    const currentDate = new Date(this.selectedYear, this.selectedMonth - 1, day);

    // Adjust the selectedFromDate to remove the extra day
    selectedFromDate.setDate(selectedFromDate.getDate() - 1);

    // Check if the current date falls within the selected range
    const isInRange = (currentDate >= selectedFromDate && currentDate <= selectedToDate) ||
      (currentDate <= selectedFromDate && currentDate >= selectedToDate);

    // Check if the current date matches the selected date
    const isCurrentDate = day === this.currentDay &&
      this.selectedMonth === (this.today.getMonth() + 1) &&
      this.selectedYear === this.today.getFullYear();

    return isInRange || isCurrentDate;
  }


  // Checking Availability
  UpdateAvailabledetails() {
    $("#LoadingImage").show();
    if ($('#Txt_From').val() == '') {
      ngswal("Warning !", "Enter From Date!", "warning");
    } else if ($('#Txt_To').val() == '') {
      ngswal("Warning !", "Enter To Date!", "warning");
    } else if ($('#TXT_Remarks').val() == '') {
      ngswal("Warning !", "Enter Remarks!", "warning");
    }
    else {

      $("#LoadingImage").show();

      var dataParam = {
        ID: localStorage.aEID,
        FromDate: $('#Txt_From').val(),
        ToDate: $('#Txt_To').val(),
        Remarks: $('#TXT_Remarks').val(),
        UpdatedBy: localStorage.aLoginID
      };

      ApiMethod.postMethod('api/freelancer/GetAvailabiltyUpdate', dataParam).subscribe(
        result => {
          this.GetFreelancerData();

          console.log(dataParam);
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated Availability !",
            text: result.aUpdatedAvailability,
            showConfirmButton: true,

          });
          this.hide();
          $("#LoadingImage").hide();
        },
        error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        }

      );
    }

  }



  availability() {
    $("LoadingImage").show();
    $("#divAddAvailability").show();
    $("#LoadingImage").hide();
  }

  ShowAvailability() {
    $("#LoadingImage").show();
    if (localStorage.aLoginID != 0) {
      ApiMethod.getMethod("api/GetFreelancerAvailabilityById/" + localStorage.aLoginID).subscribe(
        (Response) => {
          console.log(Response.aAvaialbleDate);
          if (Response.aAvaialbleDate && Response.aAvaialbleDate.length > 0) {
            var _Avaialbledata = Response.aAvaialbleDate[0];
            $('#Txt_From').val(GlobalConstants.SetValue_FormatDate(_Avaialbledata.FromDate));
            $('#Txt_To').val(GlobalConstants.SetValue_FormatDate(_Avaialbledata.ToDate));
            $('#TXT_Remarks').val(_Avaialbledata.Remarks);
            const currentDate = new Date();
            const day = currentDate.getDate();
            this.isSelectedDate(day);
          } else {
            this.ClearData();
          }
          $("#LoadingImage").hide();

        },

        (error) => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
  }
  //Delete Confirm Popup
  DeleteUnavailabity() {
    if ($('#Txt_From').val() && $('#Txt_To').val() != null) {
      ngswal({
        title: "Are you confirm to delete Unavailability Date?",
        text: "Unavailability Details !",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, Delete!",
        cancelButtonText: "No, Cancel!",
        closeOnConfirm: false,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            $('#btnDeleteConfirm').trigger("click");
          } else {
            ngswal("Cancelled", "Your data is safe :)", "warning");
            return false;
          }
        });
    } else {
      ngswal("Warning", "There is No Unavaible Date. So can't Delete Anything", "warning");
      return false;
    }

  }

  //Delete availability
  DeleteConfirm() {
    $('#LoadingImagePopup').show();

    ApiMethod.getMethod("api/DeleteUnAvailability/" + localStorage.aLoginID).subscribe(
      result => {
        $("#LoadingImagePopup").hide();
        this.hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted Successfully!",
          text: result.deleteMsg,
          showConfirmButton: false,
          timer: 1500
        });
        this.GetFreelancerData();
        this.ShowAvailability();
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //testAssigned cleardata 
  ClearData(): void {
    $("#ddlAvailbale").val(0).change();
    $("#Txt_From").val('');
    $("#Txt_To").val('');
    $("#TXT_Remarks").val('');

  }
  //End  Availabilty
  hide() {
    $("#divInfoData").hide();
    $("#divUploadData").hide();
    $("#divAddAvailability").hide();

  }
  //Download Resume
  Resumefiledownload() {
    $("#LoadingImageReopen").show();
    ApiMethod.Downloadfile(this.modelItem.getFreelancerResumefileAPI + "/" + localStorage.aEID);
    this.getpopupFreelancerdate();
    $("#LoadingImageReopen").hide();
  }
  //allocated testfile download
  testfiledownload() {
    $("#LoadingImage").show();
    ApiMethod.Downloadfile(this.modelItem.getFreelancertestfileAPI + "/" + localStorage.aEID);
    $("#LoadingImage").hide();
  }

  TestFileUpload() {
    $("#LoadingImage").show();
    $("#divUploadData").show();
    $("#LoadingImage").hide();
  }
  testfileuploads() {
    $("#LoadingImageReopen").show();
    var filedetails = {
      ID: localStorage.aEID,
      fileName: this.file.name,
      fileSize: this.file.size,
      fileAsBase64: this.fileBase64,
      VendorId: localStorage.aLoginID
    }
    console.log(filedetails);
    ApiMethod.postMethod("api/Freelancertestfileupload", filedetails).subscribe(
      response => {
        $("#LoadingImageReopen").hide();
        $('#doc_Defectuploadfile').val("");
        if (response.status == "Failed") {
          $("#LoadingImageReopen").hide();
          ngswal({
            position: "top-end",
            type: "error",
            title: "Error!",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });

        } else {
          ngswal({
            position: "top-end",
            type: "success",
            title: "Uploaded!",
            text: response.message,
            showConfirmButton: true,

          });
          $("#divUploadData").hide();
          this.GetFreelancerData();
        }
        $("#LoadingImageReopen").hide();
      }, error => {
        $("#LoadingImageReopen").hide();
        ngswal("Failed !", error.error.Message, "error");
      });
    /*return this.status;*/
  }

  onuploadSelected(fileInput: any) {

    var ext = $('#doc_Defectuploadfile').val().split('.').pop().toLowerCase();
    //if ($.inArray(ext, ['doc', 'docx', 'pdf']) == -1) {
    //  $('#doc_Defectuploadfile').val("");
    //  ngswal("Failed !", "Invalid File format", "warning");
    //  return false;
    //} else
    if (fileInput.target.files[0].size > 52428800) {
      $('#doc_Defectuploadfile').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {

      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }

  //Confirmation of Test File Upload data

  confirmation() {
    if ($('#doc_testuploadfile').val() == "") {
      $('#doc_testuploadfile').val("");
      ngswal("Failed !", "Please upload File..!", "warning");
      return;
    }
    ngswal({
      title: "File Upload Confirmation",
      text: "Are you sure Submit test file?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#testfileupload').trigger("click");
        } else {
          $('#doc_testuploadfile').val("");
          return false;
        }
      });
  }




}
